/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import TableContainer from "@material-ui/core/TableContainer";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import tableStyle from "assets/jss/material-dashboard-react/components/tableStyle";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
const useStyles = makeStyles(tableStyle);
const DisbursalBTDisabled = ({
  setNext,
  setBack,
  loanApplicationId,
  status,
  closeModal,
  customerProceedId,
  loanAccountNumber,
  showButton,
  featureFlags
}) => {
  const classes = useStyles();
  const [tableColumns] = useState([
    "Disbursal Amount",
    "Net Amount Payable",
    "Cash",
    "Bank",
  ]);
  const [disbursalDetailsObj, setDisbursalDetailsObj] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [loanStatus, setStatus] = useState("");
  const [checkId, setCheckId] = useState(true);
  const [calculatenetPayAble, setCalculatenetPayable] = useState("");
 
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetDisbursalDetails();
  }, []);

  const GetDisbursalDetails = async () => {
    setCallInProgress(true);
    //DISBURSAL_GETDATA
    const res = await apiHandler({
      url: endpoint.DISBURSAL_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error","please Provide correct disbursal Details data", true);
    } else {
      setDisbursalDetailsObj(res.data);
    }
  };
  const onBack = () => {
    setBack();
  };
  const onNext = () => {
    setNext();
  };
  const bankPaymentDetail = disbursalDetailsObj?.filter((item)=> item?.paymentMode === "BANK")
  const cashPaymentDetail = disbursalDetailsObj?.filter((item)=> item?.paymentMode === "CASH")
  const cashPayment = cashPaymentDetail?.[0]?.netPayable || 0
  const bankPaymnet = bankPaymentDetail?.[0]?.netPayable || 0
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
        <SubHeader
             label={headerLabel?.disbursal}
            subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
             onlyLabel/>
        </Grid>
      </Grid>
      <GridContainer>
        <GridItem xs={12} sm={12} md={2} lg={2} style={{ textAlign: "start" }}>
          <CustomInput
            labelText="Loan Account Number"
            formControlProps={{
              fullWidth: true,
              style: { marginTop: 0 },
            }}
            inputProps={{
              name: "loan Account Number",
              disabled: true,
              value: loanAccountNumber,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={2} lg={2} style={{ textAlign: "start" }}>
          <CustomInput
            labelText="Customer Id"
            formControlProps={{
              fullWidth: true,
              style: { marginTop: 0 },
            }}
            inputProps={{
              name: "customer Id",
              disabled: true,
              value: customerProceedId,
            }}
          />
        </GridItem>
        <GridItem xs={10} sm={10} md={6} lg={6}></GridItem>
          <GridItem
            xs={12}
            sm={12}
            md={2}
            lg={2}
            style={{ textAlign: "start" }}
          >
          <CustomInput
            labelText="Disbursal Date"
            formControlProps={{
              fullWidth: true,
              style: { marginTop: 0 },
            }}
            inputProps={{
              name: "customer Id",
              disabled: true,
              value: disbursalDetailsObj?.[0]?.disbursalDate,
            }}
          />
        </GridItem>
      </GridContainer>
      <>
        <TableContainer className={classes.tableContianer}>
          <Table
            stickyHeader
            style={{
              minWidth: window.innerWidth < 600 ? "250%" : "100%",
            }}
          >
            <TableHead>
              <TableRow className={classes.tableHeadRowDisbursal}>
                {tableColumns.map((item, i) => (
                  <TableCell
                    key={i}
                    padding="checkbox"
                    className={classes.tableCellDisbursal1}
                  >
                    {item}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow className={classes.tableBodyRowDisbursal}>
                <TableCell className={classes.disbursalBT}>
                  {
                    <CustomInput
                      id="amount"
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: 0 },
                      }}
                      inputProps={{
                        name: "disbursalAmount",
                        disabled: true,
                        value: disbursalDetailsObj?.[0]?.disbursalAmount,
                        onChange: (event) => {},
                      }}
                    />
                  }
                </TableCell>
                <TableCell className={classes.disbursalBT}>
                  {
                    <CustomInput
                      id="netpayable"
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: 0 },
                      }}
                      inputProps={{
                        name: "netPayable",
                        value: cashPayment + bankPaymnet,
                        disabled: true,
                        onChange: (event) => {},
                      }}
                    />
                  }
                </TableCell>
                <TableCell className={classes.disbursalBT}>
                  {
                    <CustomInput
                      id="cash"
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: "12px" },
                      }}
                      inputProps={{
                        name: "cash",
                        type: "number",
                        classes: { input: classes.inputStyle },
                        disabled: true,
                        value: cashPayment,
                        onChange: (event) => {},
                      }}
                    />
                  }
                </TableCell>
                <TableCell className={classes.disbursalBT}>
                  {
                    <CustomInput
                      id="bank"
                      formControlProps={{
                        fullWidth: true,
                        style: { marginTop: 0 },
                      }}
                      inputProps={{
                        name: "bank",
                        type: "number",
                        value: bankPaymnet,
                        disabled: true,
                      }}
                    />
                  }
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <GridContainer>
          <GridItem
            xs={12}
            sm={showButton ? 6 : 12}
            md={showButton ? 6 : 12}
            lg={showButton ? 6 : 12}
            style={{
              textAlign: window.innerWidth < 360 ? "center" : "right",
              marginTop: "10px",
            }}
          >
            <Button
              key={"btnB"}
              size="small"
              className={classes.nextButton1}
              disabled={callInProgress}
              onClick={() => onBack()}
            >
              Back
            </Button>
              <Button
                key={"btnP"}
                size="small"
                className={classes.nextButton1}
                onClick={() =>
                  status !== "DISBURSALTOLMS" ? closeModal() : onNext()
                }
              >
                {status !== "DISBURSALTOLMS" ? "Close" : "Next"}
              </Button>
          </GridItem>
        </GridContainer>
      </>

      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

DisbursalBTDisabled.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  closeModal: PropTypes.func,
  loanApplicationId: PropTypes.number,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.bool,
};

export default DisbursalBTDisabled;
